import { Icons } from '@/src/types/icon';

import { resetSuccessful } from '@/public/assets/icons/reset-successful';
import { error404 } from '@/public/assets/icons/404';
import {
  facebook,
  facebookStreamIcon,
  kickStreamIcon,
  twitchStreamIcon,
  youtubeStreamIcon,
  linkStreamIcon,
  twitterStreamIcon,
  instagramStreamIcon,
  tiktokStreamIcon,
} from '@/public/assets/icons/facebook';
import { hamburger } from '@/public/assets/icons/hamburgerMenu';
import { klicLogo } from '@/public/assets/icons/klicLogo';
import {
  searchGlass,
  searchWhite,
  homefillIcon,
  homelineIcon,
  nofoundIcon,
} from '@/public/assets/icons/searchGlass';
import { discoverMore } from '@/public/assets/icons/discoverMore';
import { eyeClose } from '@/public/assets/icons/eyeClose';
import { closeIcon } from '@/public/assets/icons/closeIcon';
import { google } from '@/public/assets/icons/google';
import { twitter } from '@/public/assets/icons/twitter';
import { verifySuccessful } from '@/public/assets/icons/verifySuccessful';
import { loading } from '@/public/assets/icons/loading';
import { liveIndicator } from '@/public/assets/icons/liveIndicator';
import { verified } from '@/public/assets/icons/verified';
import { playIcon } from '@/public/assets/icons/playIcon';
import { sidebarFBIcon } from '@/public/assets/icons/sidebar-fb';
import { sidebarIGIcon } from '@/public/assets/icons/sidebar-ig';
import { sidebarTwitterIcon } from '@/public/assets/icons/sidebar-twitter';
import { FooterFacebookIcon } from '@/public/assets/icons/footerFacebookIcon';
import { FooterTwitterIcon } from '@/public/assets/icons/footerTwitterIcon';
import { FooterInstagramIcon } from '@/public/assets/icons/footerInstagramIcon';
import { carouselForward } from '@/public/assets/icons/carouselForward';
import { carouselReverse } from '@/public/assets/icons/carouselReverse';
import { dropdown } from '@/public/assets/icons/dropdown';
import { featuredWatermark } from '@/public/assets/icons/featured-watermark';
import { recentWatermark } from '@/public/assets/icons/recent-watermark';
import { pause } from '@/public/assets/icons/pause';
import { zoom } from '@/public/assets/icons/zoom';
import { unmute } from '@/public/assets/icons/unmute';
import { singleView } from '@/public/assets/icons/singleView';
import { multiView } from '@/public/assets/icons/multiView';
import { aboutUsIcon } from '@/public/assets/icons/aboutUsIcon';
import { eventAltIcon } from '@/public/assets/icons/eventAltIcon';
import { eventIcon } from '@/public/assets/icons/eventIcon';
import { homeAltIcon } from '@/public/assets/icons/homeAlt';
import { homeIcon } from '@/public/assets/icons/homeIcon';
import { profileIcon } from '@/public/assets/icons/profileIcon';
import { settingsIcon } from '@/public/assets/icons/settingsIcon';
import { shopIcon } from '@/public/assets/icons/shopIcon';
import {
  calendarIcon,
  calendarPink,
  editor,
} from '@/public/assets/icons/calendarIcon';
import { caretLeftIcon } from '@/public/assets/icons/caretLeftIcon';
import { caretRightIcon } from '@/public/assets/icons/caretRightIcon';
import { clockIcon } from '@/public/assets/icons/clockIcon';
import { analytics } from '@/public/assets/icons/analytics';
import { editEvent } from '@/public/assets/icons/editEvent';
import { mute } from '@/public/assets/icons/mute';
import { paymentSuccess } from '@/public/assets/icons/paymentSuccess';
import { paymentBg } from '@/public/assets/icons/paymentBg';
import { cardPay } from '@/public/assets/icons/cardPay';
import { paypalPay } from '@/public/assets/icons/paypalPay';
import { cashappPay } from '@/public/assets/icons/cashappPay';
import { applePay } from '@/public/assets/icons/applePay';
import { mastercard } from '@/public/assets/icons/mastercard';
import { plus } from '@/public/assets/icons/plus';
import { close } from '@/public/assets/icons/close';
import { drag } from '@/public/assets/icons/drag';
import { chatClose } from '@/public/assets/icons/chatClose';
import { chatOpen } from '@/public/assets/icons/chatOpen';
import { caretDown } from '@/public/assets/icons/tinyCaretDown';
import { twitchLogo } from '@/public/assets/icons/twitchLogo';
import { discordLogo } from '@/public/assets/icons/discordLogo';
import { chatFacebookLogo } from '@/public/assets/icons/chatFacebookLogo';
import { switchStream } from '@/public/assets/icons/switchStream';
import { forward } from '@/public/assets/icons/forward';
import { fourView } from '@/public/assets/icons/fourView';
import { reverse } from '@/public/assets/icons/reverse';
import { twitch } from '@/public/assets/icons/twitch';
import { twoView } from '@/public/assets/icons/twoView';
import { discord } from '@/public/assets/icons/discord';
import { chatFacebook } from '@/public/assets/icons/chatFacebook';
import { arrowRight } from '@/public/assets/icons/arrowRight';
import { angleDown } from '@/public/assets/icons/angleDown';
import { buffer } from '@/public/assets/icons/buffer';
import { eye } from '@/public/assets/icons/eye';
import { rocket } from '@/public/assets/icons/rocket';
import { twoComputerScreens } from '@/public/assets/icons/twoComputerScreens';
import { upcomingEvents } from '@/public/assets/icons/upcomingEvents';
import { whatPeopleSay } from '@/public/assets/icons/whatPeopleSay';
import { ellipse1 } from '@/public/assets/icons/ellipse1';
import { arrow_chevron_left } from '@/public/assets/icons/arrow_chevron_left';
import { arrow_chevron_left_active } from '@/public/assets/icons/arrow_chevron_left_active';
import { arrow_chevron_right } from '@/public/assets/icons/arrow_chevron_right';
import { arrow_chevron_right_active } from '@/public/assets/icons/arrow_chevron_right_active';
import { youtube } from '@/public/assets/icons/youtube';
import { singleViewMovil } from '@/public/assets/icons/singleViewMovil';
import { multiViewMovil } from '@/public/assets/icons/multiViewMovil';
import { aboutUsAltIcon } from '@/public/assets/icons/aboutUsAltIcon';
import { user, ban } from '@/public/assets/icons/user';
import { userAlt } from '@/public/assets/icons/userAlt';
import { phone } from '@/public/assets/icons/phone';
import { phoneAlt } from '@/public/assets/icons/phoneAlt';
import { arrowMenuOpen } from '@/public/assets/icons/arrowMenuOpen';
import { arrowMenuClose } from '@/public/assets/icons/arrowMenuClose';
import { streamInvByEmail } from '@/public/assets/icons/StreamInvByEmail';
import { streamEmbed } from '@/public/assets/icons/StreamEmbed';
import { streamDrag } from '@/public/assets/icons/StreamDrag';
import { threeDots } from '@/public/assets/icons/threeDots';
import { checkmarkIcon } from '@/public/assets/icons/checkmark';
import { analyticsWhite } from '@/public/assets/icons/analyticsWhite';
import { following } from '@/public/assets/icons/following';
import { community, resources } from '@/public/assets/icons/community';
import { content } from '@/public/assets/icons/content';
import { monetization } from '@/public/assets/icons/monetization';
import { calendarStar } from '@/public/assets/icons/calendarStar';
import { notification } from '@/public/assets/icons/notification';
import { padlock } from '@/public/assets/icons/padlock';
import { arrowDown } from '@/public/assets/icons/arrowDown';
import { filledHeart } from '@/public/assets/icons/filledHeart';
import { fullscreen } from '@/public/assets/icons/fullscreen';
import { settingsWhite } from '@/public/assets/icons/settingsWhite';
import {
  viewers,
  resourcesV,
  legal,
  lunacy,
  followingIcon,
} from '@/public/assets/icons/viewers';
import { starBox } from '@/public/assets/icons/starBox';
import { redCircle } from '@/public/assets/icons/redCircle';
import { informationIcon } from '@/public/assets/icons/information';
import { vectorIcon } from '@/public/assets/icons/vector';
import { alert } from '@/public/assets/icons/alert';
import { verifyEmail } from '@/public/assets/icons/verifyEmail';
import { dragIconSmall } from '@/public/assets/icons/dragIconSmall';
import { checkBlack } from '@/public/assets/icons/checkBlack';
import { facebookLogo } from '@/public/assets/icons/facebook-logo';
import { discordLogo as newDiscordLogo } from '@/public/assets/icons/discord-logo';
import { youtubeLogo } from '@/public/assets/icons/youtube-logo';
import { twitchLogo as newTwitchLogo } from '@/public/assets/icons/twitch-logo';
import { klicLogo as newKlicLogo } from '@/public/assets/icons/klic-logo';
import { cog } from '@/public/assets/icons/cog';
import { warning } from '@/public/assets/icons/warning';
import { forgotPassword } from '@/public/assets/icons/forgotPassword';
import { newPassword } from '@/public/assets/icons/newPassword';
import { newPasswordSuccess } from '@/public/assets/icons/newPasswordSuccess';
import {
  logoShort,
  logoShortLive,
  logoShortStop,
} from '@/public/assets/icons/logoShort';
import { homePageSetup } from '@/public/assets/icons/homePageSetup';
import { manageUsers } from '@/public/assets/icons/manageUsers';
import { configManageSponsors } from '@/public/assets/icons/configManageSponsors';
import { configManageOffers } from '@/public/assets/icons/configManageOffers';
import { configManageEvents } from '@/public/assets/icons/configManageEvents';
import { adminAnalytics } from '@/public/assets/icons/adminAnalytics';
import { adminMonetization } from '@/public/assets/icons/adminMonetization';

import { webPage } from '@/public/assets/icons/webPage';
import { klicStream } from '@/public/assets/icons/klicStream';

import { background } from '@/public/assets/icons/background';
import { crownOwner } from '@/public/assets/icons/crownOwner';
import { burgerMenu } from '@/public/assets/icons/burgerMenu';
import { thumbUp } from '@/public/assets/icons/thumbUp';
import { streamManager } from '@/public/assets/icons/streamManager';
import { contentManager } from '@/public/assets/icons/contentManager';
import { eventsGear } from '@/public/assets/icons/eventsGear';
import { accountGroup } from '@/public/assets/icons/accountGroup';
import { money } from '@/public/assets/icons/money';
import { cameraWeb } from '@/public/assets/icons/cameraWeb';
import { dollarThumbnails } from '@/public/assets/icons/dollarThumbnail';
import { starThumbnail } from '@/public/assets/icons/starThumbnail';
import {
  lockThumbnail,
  embedIcon,
  klicEmbedIcon,
} from '@/public/assets/icons/lockThumbnail';
import { checkThumbnail } from '@/public/assets/icons/checkThumbnail';
import { deleteIcon } from '@/public/assets/icons/delete';
import { pencil } from '@/public/assets/icons/pencil';
import { seekForward } from '@/public/assets/icons/seekForward';
import { volumeHigh } from '@/public/assets/icons/volumeHigh';
import { volumeLow } from '@/public/assets/icons/volumeLow';
import { seekBackward } from '@/public/assets/icons/seekBackward';
import { rotate } from '@/public/assets/icons/rotate';
import { greenCircle } from '@/public/assets/icons/greenCircle';
import { mmultiviewConfiguration } from '@/public/assets/icons/mmultiviewConfiguration';
import { eventoverviewCalendar } from '@/public/assets/icons/eventoverviewCalendar';
import { eventoverviewChat } from '@/public/assets/icons/eventoverviewChat';
import { eventoverviewAccount } from '@/public/assets/icons/eventoverviewAccount';
import { eventoverviewAccountGroup } from '@/public/assets/icons/eventoverviewAccountGroup';
import { eventoverviewAds } from '@/public/assets/icons/eventoverviewAds';
import { streamNumber } from '@/public/assets/icons/streamNumber';
import { plusIcon } from '@/public/assets/icons/plusIcon';
import { logoWithoutBeta } from '@/public/assets/icons/logoWithoutBeta';
import { logoBeta } from '@/public/assets/icons/logoBeta';
import {
  deleteRed,
  removeStream,
  streamHide,
  streamUnHide,
} from '@/public/assets/icons/deleteRed';
import { creditCardFilled } from '@/public/assets/icons/creditCardFilled';
import { payPal } from '@/public/assets/icons/payPal';
import { lock, lockV2, lockRed } from '@/public/assets/icons/lock';
import { pencilEdit } from '@/public/assets/icons/pencilEdit';
import { stopEvent } from '@/public/assets/icons/stopEvent';
import { deleteEvent } from '@/public/assets/icons/deleteEvent';
import { filterIcon } from '@/public/assets/icons/filterIcon';
import { checkPrimary } from '@/public/assets/icons/checkPrimary';
import { fillHeartIcon } from '@/public/assets/icons/fillHeartIcon';
import { cleanHeartIcon } from '@/public/assets/icons/cleanHeartIcon';
import { titleSperator } from '@/public/assets/icons/titleSperator';
import {
  dashboardMobile,
  eventMobile,
  logoutMobile,
  analyticsMobile,
  subscriptionMobile,
  mychannelMobile,
  settingMobile,
} from '@/public/assets/icons/dashboardMobile';
import {
  SubscribeIcon,
  SubscribeOnly,
  ContactUs,
  CookiePrference,
  CookiePrferenceV1,
  PrivacyPolicy,
  TermsOfUse,
  TermsOfUsesm,
  ContactUssm,
  DMCA,
  PricingIcon,
  CookiePrferencesm,
  LoginIcon,
} from '@/public/assets/icons/SubscribeIcon';

import { verticaltreedots } from '@/public/assets/icons/verticaltreedots';
import { stopIcon, startIcon } from '@/public/assets/icons/stopIcon';
import { bluelock, blueUnlock } from '@/public/assets/icons/bluelock';
import { dollor } from '@/public/assets/icons/dollor';
import { subscriber, subscriberNew } from '@/public/assets/icons/subscriber';
import { follower } from '@/public/assets/icons/follower';
import { clipboard, clipboardWhite } from '@/public/assets/icons/clipboard';
import { CommunityIcon } from '../../public/assets/icons/SubscribeIcon';
import { footerYoutube } from '@/public/assets/icons/footerYoutube';
import { footerFacebook } from '@/public/assets/icons/footerFacebook';
import { footerTwitter } from '@/public/assets/icons/footerTwitter';
import { footerInstagram } from '@/public/assets/icons/footerInstagram';
import { footerDiscord } from '@/public/assets/icons/footerDiscord';
import { footerTwitch } from '../../public/assets/icons/footerDiscord';
import { PpvDollar } from '@/public/assets/icons/ppvdollar';
import { thumb } from '@/public/assets/icons/thumb';
import { addfree } from '@/public/assets/icons/addfree';
import { winner } from '@/public/assets/icons/winner';
import { menuClose } from '@/public/assets/icons/menuClose';
import { gallery } from '@/public/assets/icons/gallery';
import { plusRound } from '@/public/assets/icons/plusRound';
import { UnionIcon } from '@/public/assets/icons/UnionIcon';
import { Coin } from '@/public/assets/icons/Coin';
import { checkPink } from '@/public/assets/icons/checkPink';
import { plusPink } from '@/public/assets/icons/plusPink';
import { mugIcon } from '@/public/assets/icons/mugIcon';
import { eyePink } from '@/public/assets/icons/eyePink';
import { lockSubscriber } from '@/public/assets/icons/lockSubscriber';
import { messageBanned } from '@/public/assets/icons/messageBanned';
import { arrowGradiant } from '@/public/assets/icons/arrowGradiant';
import { popoutGradiant } from '@/public/assets/icons/popoutGradiant';
import { toolGradiant } from '@/public/assets/icons/toolGradiant';
import { messenger } from '@/public/assets/icons/messenger';
import { back } from '@/public/assets/icons/back';
import { streamIcon } from '@/public/assets/icons/streamIcon';

import {
  dashboardCalendar,
  dashboardCalendarDown,
} from '@/public/assets/icons/dashboardCalendar';
import {
  revenueDropDown,
  revenueHigh,
  revenueLow,
  revenueBack,
  revenueNext,
} from '@/public/assets/icons/revenue';
import { trash } from '@/public/assets/icons/trash';
import { dragPanel } from '@/public/assets/icons/dragPanel';
import {
  sortAscending,
  sortDescending,
} from '@/public/assets/icons/sortAscending';
import { Helicopter } from '@/public/assets/icons/Helicopter';
import { keyboard } from '@/public/assets/icons/keyboard';
import { activeKeyboard } from '@/public/assets/icons/activeKeyboard';
import { Share } from '@/public/assets/icons/Share';

import { singleViewnew } from '@/public/assets/icons/singleViewnew';
import { doubleView } from '@/public/assets/icons/doubleView';
import { tripleView } from '@/public/assets/icons/tripleView';
import { fourViewnew } from '@/public/assets/icons/fourViewnew';
import { fiveView } from '@/public/assets/icons/fiveView';
import { sixView } from '@/public/assets/icons/sixView';
import { nineView } from '@/public/assets/icons/nineView';
import { Unlock } from '@/public/assets/icons/Unlock';
import { colUnlock } from '@/public/assets/icons/colUnlock';
import { sync } from '@/public/assets/icons/sync';
import { tool } from '@/public/assets/icons/tool';
import { messageIcon } from '@/public/assets/icons/messageIcon';
import { pinIcon } from '@/public/assets/icons/pinIcon';
import { lockFollower } from '@/public/assets/icons/lockFollower';
import { closeHighlighted } from '@/public/assets/icons/closeHighlighted';
import { starShine } from '@/public/assets/icons/starShine';

import { deletePanel, ageRestricted } from '@/public/assets/icons/deletePanel';
import {
  Union,
  ArrowTop,
  ListArrow,
  PanelInfo,
} from '@/public/assets/icons/panels';
import {
  DashboardRevenue,
  DashboardFollower,
  DashboardEvents,
  SidebarAnalytic,
  SidebarOrganization,
  SidebarCommunity,
  SidebarSupport,
  DashboardViews,
} from '../../public/assets/icons/DashboardIcon';
import {
  showMore,
  showLess,
  backTo,
  logout,
  Offline,
} from '../../public/assets/icons/show';
import {
  CategoryFollow,
  CategoryUnFollow,
} from '../../public/assets/icons/category';
import {
  SidebarEvents,
  SidebarMonetization,
} from '../../public/assets/icons/DashboardIcon';
import { singleViewnewActive } from '../../public/assets/icons/singleViewnewActive';
import { doubleViewActive } from '../../public/assets/icons/doubleViewActive';
import { tripleViewActive } from '../../public/assets/icons/tripleViewActive';
import { fourViewnewActive } from '../../public/assets/icons/fourViewNewActive';
import { fiveViewActive } from '../../public/assets/icons/fiveViewActive';
import { sixViewActive } from '../../public/assets/icons/sixViewActive';
import { nineViewActive } from '../../public/assets/icons/nineViewActive';
import { HelicopterActive } from '@/public/assets/icons/HelicopterActive';
import { emojiIcon } from '@/public/assets/icons/emoji';
import { pinMessage } from '@/public/assets/icons/countries/pinMessage';
import { unpinMessage } from '@/public/assets/icons/countries/unpinMessage';
import { inbox, notify, notificationFill } from '@/public/assets/icons/inbox';
import { notificationEmpty } from '@/public/assets/icons/notificationEmpty';
import { infoIcon } from '@/public/assets/icons/infoIcon';
import { upload } from '@/public/assets/icons/upload';
import { send } from '@/public/assets/icons/send';
import { crownSub } from '@/public/assets/icons/crownSub';
import { noAds } from '@/public/assets/icons/noAds';

import {
  eventListIcon,
  eventDetailIcon,
} from '@/public/assets/icons/eventListIcon';
export const icons: Record<Icons, string> = {
  klicStream,
  follower,
  subscriber,
  subscriberNew,
  dollor,
  thumb,
  winner,
  addfree,
  '404': error404,
  appLogo: klicLogo,
  hamburger: hamburger,
  searchIcon: searchGlass,
  discoverMore: discoverMore,
  eyeHide: eyeClose,
  closeIcon: closeIcon,
  googleIcon: google,
  facebookIcon: facebook,
  twitterIcon: twitter,
  verifySent: verifySuccessful,
  resetSuccessful: resetSuccessful,
  loading: loading,
  liveIndicator: liveIndicator,
  playIcon: playIcon,
  verifiedIcon: verified,
  sidebarFBIcon: sidebarFBIcon,
  sidebarIGIcon: sidebarIGIcon,
  sidebarTwitterIcon: sidebarTwitterIcon,
  footerFacebookIcon: FooterFacebookIcon,
  footerInstagramIcon: FooterInstagramIcon,
  footerTwitterIcon: FooterTwitterIcon,
  carouselForward,
  carouselReverse,
  dropdown,
  featuredWatermark,
  recentWatermark,
  pause,
  zoom,
  unmute,
  singleView,
  multiView,
  aboutUsIcon: aboutUsIcon,
  eventAltIcon: eventAltIcon,
  eventIcon: eventIcon,
  homeAltIcon: homeAltIcon,
  homeIcon: homeIcon,
  profileIcon: profileIcon,
  settingsIcon: settingsIcon,
  shopIcon: shopIcon,
  analytics: analytics,
  editEvent: editEvent,
  mute,
  calendarIcon: calendarIcon,
  caretLeftIcon: caretLeftIcon,
  caretRightIcon: caretRightIcon,
  clockIcon: clockIcon,
  paymentSuccess,
  paymentBg,
  plus,
  calendarPink,
  editor,
  close,
  cardPay,
  cashappPay,
  applePay,
  paypalPay,
  lockV2,
  mastercard,
  drag,
  chatClose,
  chatOpen,
  caretDown,
  twitchLogo,
  discordLogo,
  chatFacebookLogo,
  switchStream,
  forward,
  fourView,
  reverse,
  twitch,
  twoView,
  discord,
  chatFacebook,
  arrowRight,
  angleDown,
  buffer,
  eye,
  rocket,
  twoComputerScreens,
  upcomingEvents,
  whatPeopleSay,
  ellipse1,
  arrow_chevron_left,
  arrow_chevron_left_active,
  arrow_chevron_right,
  arrow_chevron_right_active,
  youtube,
  singleViewMovil,
  multiViewMovil,
  aboutUsAltIcon,
  user,
  userAlt,
  phone,
  phoneAlt,
  arrowMenuOpen,
  arrowMenuClose,
  streamInvByEmail,
  streamEmbed,
  streamDrag,
  threeDots,
  checkmarkIcon,
  analyticsWhite,
  following,
  community,
  content,
  monetization,
  calendarStar,
  notification,
  padlock,
  filledHeart,
  arrowDown,
  fullscreen,
  settingsWhite,
  viewers,
  resourcesV,
  legal,
  lunacy,
  followingIcon,
  starBox,
  redCircle,
  informationIcon,
  vectorIcon,
  alert,
  verifyEmail,
  dragIconSmall,
  checkBlack,
  facebookLogo,
  newDiscordLogo,
  newTwitchLogo,
  youtubeLogo,
  newKlicLogo,
  cog,
  forgotPassword,
  newPassword,
  newPasswordSuccess,
  logoShort,
  logoShortLive,
  logoShortStop,
  adminAnalytics,
  adminMonetization,
  configManageEvents,
  configManageOffers,
  configManageSponsors,
  manageUsers,
  homePageSetup,
  webPage,
  background,
  crownOwner,
  burgerMenu,
  thumbUp,
  streamManager,
  contentManager,
  eventsGear,
  accountGroup,
  money,
  cameraWeb,
  dollarThumbnails,
  starThumbnail,
  lockThumbnail,
  checkThumbnail,
  deleteIcon,
  pencil,
  seekBackward,
  seekForward,
  volumeHigh,
  volumeLow,
  rotate,
  greenCircle,
  mmultiviewConfiguration,
  eventoverviewCalendar,
  eventoverviewChat,
  eventoverviewAccount,
  eventoverviewAccountGroup,
  eventoverviewAds,
  streamNumber,
  plusIcon,
  logoBeta,
  logoWithoutBeta,
  deleteRed,
  creditCardFilled,
  payPal,
  lock,
  pencilEdit,
  stopEvent,
  deleteEvent,
  filterIcon,
  checkPrimary,
  fillHeartIcon,
  cleanHeartIcon,
  SubscribeIcon,
  LoginIcon,
  CookiePrferencesm,
  ban,
  SubscribeOnly,
  PricingIcon,
  ContactUs,
  CookiePrference,
  CookiePrferenceV1,
  PrivacyPolicy,
  TermsOfUse,
  TermsOfUsesm,
  ContactUssm,
  titleSperator,
  verticaltreedots,
  stopIcon,
  bluelock,
  blueUnlock,
  clipboard,
  clipboardWhite,
  DMCA,
  CommunityIcon,
  footerFacebook,
  footerTwitter,
  footerInstagram,
  footerYoutube,
  footerDiscord,
  footerTwitch,
  showMore,
  showLess,
  backTo,
  logout,
  DashboardRevenue,
  DashboardFollower,
  DashboardEvents,
  DashboardViews,
  SidebarAnalytic,
  SidebarEvents,
  SidebarMonetization,
  SidebarOrganization,
  SidebarCommunity,
  SidebarSupport,
  CategoryFollow,
  Offline,
  CategoryUnFollow,
  PpvDollar,
  startIcon,
  ArrowTop,
  Union,
  ListArrow,
  PanelInfo,
  resources,
  menuClose,
  gallery,
  dashboardCalendar,
  dashboardCalendarDown,
  revenueDropDown,
  revenueHigh,
  revenueLow,
  revenueBack,
  revenueNext,
  dragPanel,
  deletePanel,
  ageRestricted,
  trash,
  warning,
  plusRound,
  UnionIcon,
  Coin,
  sortAscending,
  sortDescending,
  Helicopter,
  HelicopterActive,
  Share,
  singleViewnew,
  singleViewnewActive,
  doubleView,
  doubleViewActive,
  tripleView,
  tripleViewActive,
  fourViewnew,
  fourViewnewActive,
  fiveView,
  fiveViewActive,
  sixView,
  sixViewActive,
  nineView,
  nineViewActive,
  Unlock,
  colUnlock,
  keyboard,
  activeKeyboard,
  sync,
  plusPink,
  checkPink,
  mugIcon,
  eyePink,
  tool,
  messageIcon,
  pinIcon,
  lockFollower,
  lockSubscriber,
  closeHighlighted,
  starShine,
  messageBanned,
  arrowGradiant,
  popoutGradiant,
  toolGradiant,
  messenger,
  back,
  streamIcon,
  dashboardMobile,
  eventMobile,
  logoutMobile,
  analyticsMobile,
  subscriptionMobile,
  mychannelMobile,
  settingMobile,
  emojiIcon,
  pinMessage,
  unpinMessage,
  searchWhite,
  homefillIcon,
  homelineIcon,
  nofoundIcon,
  removeStream,
  streamHide,
  streamUnHide,
  lockRed,
  inbox,
  notificationEmpty,
  eventListIcon,
  eventDetailIcon,
  facebookStreamIcon,
  kickStreamIcon,
  twitchStreamIcon,
  youtubeStreamIcon,
  twitterStreamIcon,
  instagramStreamIcon,
  tiktokStreamIcon,
  linkStreamIcon,
  embedIcon,
  klicEmbedIcon,
  infoIcon,
  upload,
  send,
  crownSub,
  noAds,
  notify,
  notificationFill,
};
